import { render } from "./ChroniclesListView.vue?vue&type=template&id=1e43322c&scoped=true"
import script from "./ChroniclesListView.vue?vue&type=script&lang=js"
export * from "./ChroniclesListView.vue?vue&type=script&lang=js"

import "./ChroniclesListView.vue?vue&type=style&index=0&id=1e43322c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e43322c"]])

export default __exports__